export const services = {
  is: {
    title: "Þjónusta sem skilar árangri",
    description: "Við bjóðum upp á heildstæða þjónustu í stafrænni þróun. Frá hugmynd að fullkláruðu verkefni og áframhaldandi viðhaldi.",
    sections: {
      webDevelopment: {
        title: "Vefsíðugerð",
        description: "Við sérhæfum okkur í þróun á opnum veflausnum og sérsniðnum kerfum sem skila raunverulegum árangri fyrir þitt fyrirtæki."
      },
      webDesign: {
        title: "Vefhönnun",
        description: "Við hönnun fallegar og áhrifaríkar vefsíður sem skila raunverulegum árangri fyrir þitt fyrirtæki."
      },
      webProgramming: {
        title: "Vefþróun",
        description: "Við þróum sérsniðnar veflausnir með nýjustu tækni fyrir hámarks afköst."
      },
      consulting: {
        title: "Ráðgjöf",
        description: "Stefnumiðuð ráðgjöf til að hjálpa þér að taka upplýstar ákvarðanir um þínar stafrænu lausnir."
      },
      marketing: {
        title: "Markaðssetning",
        description: "Árangursríkar stafrænar markaðssetningaraðferðir sem auka sýnileika og skila árangri."
      },
      seo: {
        title: "Leitarvélabestun",
        description: "Bættu leitarvélabestun vefsíðunnar þinnar fyrir betri sýnileika í leitarvélum og auktu lífræna umferð."
      },
      analytics: {
        title: "Greiningar",
        description: "Fáðu gagnlegar upplýsingar úr gögnum og taktu upplýstar ákvarðanir byggðar á greiningum."
      },
      maintenance: {
        title: "Viðhald",
        description: "Viðvarandi stuðningur og viðhald til að halda vefsíðunni þinni öruggri og uppfærðri."
      }
    },
    cta: {
      title: "Tilbúin að hefja þitt verkefni?",
      description: "Láttu okkur hjálpa þér að byggja upp öfluga veflausn sem uppfyllir þínar þarfir"
    }
  },
  en: {
    title: "Services that deliver results",
    description: "We offer comprehensive services in digital development. From concept to completed project and ongoing maintenance.",
    sections: {
      webDevelopment: {
        title: "Web Development",
        description: "We specialize in developing open web solutions and custom systems that deliver real results for your business."
      },
      webDesign: {
        title: "Web Design",
        description: "We create beautiful and effective websites that deliver real results for your business."
      },
      webProgramming: {
        title: "Web Programming",
        description: "We develop custom web solutions with the latest technology for maximum performance."
      },
      consulting: {
        title: "Consulting",
        description: "Strategic advice to help you make informed decisions about your digital solutions."
      },
      marketing: {
        title: "Marketing",
        description: "Effective digital marketing strategies that increase visibility and drive results."
      },
      seo: {
        title: "SEO",
        description: "Optimize your website for better visibility in search engines and increase organic traffic."
      },
      analytics: {
        title: "Analytics",
        description: "Gain valuable insights from data and make informed decisions based on analytics."
      },
      maintenance: {
        title: "Maintenance",
        description: "Ongoing support and maintenance to keep your website secure and up-to-date."
      }
    },
    cta: {
      title: "Ready to start your project?",
      description: "Let us help you build a powerful web solution that meets your needs"
    }
  },
  es: {
    title: "Servicios que entregan resultados",
    description: "Ofrecemos servicios integrales en desarrollo digital. Desde la idea hasta el proyecto terminado y mantenimiento continuo.",
    sections: {
      webDevelopment: {
        title: "Desarrollo Web",
        description: "Nos especializamos en desarrollar soluciones web abiertas y sistemas personalizados que entregan resultados reales para su empresa."
      },
      webDesign: {
        title: "Diseño Web",
        description: "Creamos sitios web hermosos y efectivos que entregan resultados reales para su empresa."
      },
      webProgramming: {
        title: "Programación Web",
        description: "Desarrollamos soluciones web personalizadas con la última tecnología para un rendimiento máximo."
      },
      consulting: {
        title: "Consultoría",
        description: "Asesoramiento estratégico para ayudarle a tomar decisiones informadas sobre sus soluciones digitales."
      },
      marketing: {
        title: "Marketing",
        description: "Estrategias efectivas de marketing digital que aumentan la visibilidad y generan resultados."
      },
      seo: {
        title: "SEO",
        description: "Optimice su sitio web para obtener mejor visibilidad en los motores de búsqueda y aumentar el tráfico orgánico."
      },
      analytics: {
        title: "Analítica",
        description: "Obtenga información valiosa de los datos y tome decisiones informadas basadas en análisis."
      },
      maintenance: {
        title: "Mantenimiento",
        description: "Soporte y mantenimiento continuos para mantener su sitio web seguro y actualizado."
      }
    },
    cta: {
      title: "¿Listo para comenzar su proyecto?",
      description: "Déjenos ayudarle a construir una solución web potente que satisfaga sus necesidades"
    }
  },
  da: {
    title: "Tjenester der leverer resultater",
    description: "Vi tilbyder omfattende tjenester inden for digital udvikling. Fra koncept til færdigt projekt og løbende vedligeholdelse.",
    sections: {
      webDevelopment: {
        title: "Webudvikling",
        description: "Vi specialiserer os i at udvikle åbne webløsninger og skræddersyede systemer, der leverer reelle resultater for din virksomhed."
      },
      webDesign: {
        title: "Webdesign",
        description: "Vi skaber smukke og effektive websteder, der leverer reelle resultater for din virksomhed."
      },
      webProgramming: {
        title: "Webprogrammering",
        description: "Vi udvikler skræddersyede webløsninger med den nyeste teknologi for maksimal ydeevne."
      },
      consulting: {
        title: "Rådgivning",
        description: "Strategisk rådgivning for at hjælpe dig med at træffe informerede beslutninger om dine digitale løsninger."
      },
      marketing: {
        title: "Marketing",
        description: "Effektive digitale markedsføringsstrategier, der øger synligheden og skaber resultater."
      },
      seo: {
        title: "SEO",
        description: "Optimer dit websted for bedre synlighed i søgemaskiner og øg den organiske trafik."
      },
      analytics: {
        title: "Analyse",
        description: "Få værdifuld indsigt fra data og træf informerede beslutninger baseret på analyser."
      },
      maintenance: {
        title: "Vedligeholdelse",
        description: "Løbende support og vedligeholdelse for at holde dit websted sikkert og opdateret."
      }
    },
    cta: {
      title: "Klar til at starte dit projekt?",
      description: "Lad os hjælpe dig med at bygge en kraftfuld webløsning, der opfylder dine behov"
    }
  }
}; 